/* eslint-disable */
import staticData from '../../static_data/all';

export function loadAnalyticsScript(name, isDebugEnabled) {
    if (isDebugEnabled) {
      ;(function(i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r
        ;(i[r] =
          i[r] ||
          function() {
            ;(i[r].q = i[r].q || []).push(arguments)
          }),
          (i[r].l = 1 * new Date())
        ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
        a.async = 1
        a.src = g
        m.parentNode.insertBefore(a, m)
      })(
        window,
        document,
        'script',
        'https://www.google-analytics.com/analytics_debug.js',
        name
      )
    } else {
      ;(function(i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r
        ;(i[r] =
          i[r] ||
          function() {
            ;(i[r].q = i[r].q || []).push(arguments)
          }),
          (i[r].l = 1 * new Date())
        ;(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0])
        a.async = 1
        a.src = g
        m.parentNode.insertBefore(a, m)
      })(
        window,
        document,
        'script',
        'https://www.google-analytics.com/analytics.js',
        name
      )
    }
}

var isDebugEnabled = false

if (typeof window !== 'undefined' && !staticData.useStatic) {
  loadAnalyticsScript('abGoogleAnalytics', isDebugEnabled)
}



// WEBPACK FOOTER //
// ./src/utils/tracking/googleAnalyticsLoader.js